import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { StoreSearchReducedFragmentDoc } from '../fragments/storeSearchReduced.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StoreSearchAdminReducedQueryVariables = Types.Exact<{
  query: Types.Scalars['String'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type StoreSearchAdminReducedQuery = { __typename?: 'Query', storeSearchAdmin: Array<{ __typename?: 'StoreSearchResult', id: string, name?: string | null, store?: { __typename?: 'Store', id: string, name?: string | null, external_vytal_id?: string | null, brand_id?: string | null } | null }> };


export const StoreSearchAdminReducedDocument = gql`
    query storeSearchAdminReduced($query: String!, $limit: Int) {
  storeSearchAdmin(query: $query, limit: $limit, search_address: false) {
    ...StoreSearchReduced
  }
}
    ${StoreSearchReducedFragmentDoc}`;

/**
 * __useStoreSearchAdminReducedQuery__
 *
 * To run a query within a React component, call `useStoreSearchAdminReducedQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreSearchAdminReducedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreSearchAdminReducedQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useStoreSearchAdminReducedQuery(baseOptions: Apollo.QueryHookOptions<StoreSearchAdminReducedQuery, StoreSearchAdminReducedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreSearchAdminReducedQuery, StoreSearchAdminReducedQueryVariables>(StoreSearchAdminReducedDocument, options);
      }
export function useStoreSearchAdminReducedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreSearchAdminReducedQuery, StoreSearchAdminReducedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreSearchAdminReducedQuery, StoreSearchAdminReducedQueryVariables>(StoreSearchAdminReducedDocument, options);
        }
export type StoreSearchAdminReducedQueryHookResult = ReturnType<typeof useStoreSearchAdminReducedQuery>;
export type StoreSearchAdminReducedLazyQueryHookResult = ReturnType<typeof useStoreSearchAdminReducedLazyQuery>;
export type StoreSearchAdminReducedQueryResult = Apollo.QueryResult<StoreSearchAdminReducedQuery, StoreSearchAdminReducedQueryVariables>;